<script>
import _ from 'lodash';

export default {
  name: 'program-utils',
  computed: {},
  data() {
    return {
      programLoading: false,
      programLoadError: false,
      program: {},
      initialProgram: {},
    };
  },
  methods: {
    async getProgram({ slug, getPricing } = {}) {
      let id = slug;
      if (!slug) {
        const { params } = this.$route;
        const { slug } = params;
        id = slug;
      }
      this.programLoading = true;
      this.programLoadError = false;
      try {
        const { program } = await this.$students({
          method: 'getProgramData',
          payload: {
            slug: id,
            getPricing,
          },
        });
        this.$log.info('getProgram: ', program);
        this.program = program;
        this.initialProgram = _.cloneDeep(program);
      } catch (e) {
        const message = e.message || e;
        this.programLoadError = 'Hubo un problema al cargar este programa. Inténtalo de nuevo en unos momentos.';
        this.$log.error(message);
      } finally {
        this.programLoading = false;
      }
    },
  },
};
</script>
